import React from 'react'
import Typography from '@material-ui/core/Typography';
import styled from 'styled-components';
import useFetchData from '../../crud/useFetchData';
import GraficoAno from './GraficoAno';

const Content = styled.div`
  padding: 15px;
  display: flex;
  flex-direction: column;
  align-items: center;
`

export default function MoreInfo(props) {
  const { f, modalData={} } = props;
  const { graph } = modalData;
  if (graph) return <GraficoAno {...props} dados={modalData} />
  const { data } = useFetchData(f.url, {opt: f.opt})
  return (
    <MoreInfoUI
      data={data}
      {...props}
    />
  )
}

function MoreInfoUI (props) {
  const { titulo, subtitulo, children, data } = props;
  return (
    <Content>
      <Typography variant="title" color="inherit">
        {titulo}
      </Typography>
      <Typography variant="title" color="inherit">
        {subtitulo}
      </Typography>
      {children(data)}
    </Content>
  )
}
